import { apiCommon } from 'lib/utils/axios';
import logrocket from '@/services/logrocket';

const CURRENCIES_URL = '/currency';

export const getCurrencies = async () => {
  try {
    const { data } = await apiCommon.get(CURRENCIES_URL);

    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};
